import { Component } from '@angular/core';
import { UiModule } from '@components/ui/ui-module';

@Component({
  selector: 'lgb-cgv',
  imports: [
    UiModule
  ],
  templateUrl: './cgv.html',
  styleUrl: './cgv.css',
})
export class Cgv {

}
